import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../../../shared/shared.module';
import { KKM_NETWORK_TARIFF } from './kkm-network-info.config';
import { KkmNetworkBillingStatusModel } from './kkm-network-info.types';
import { KkmSettingsNavigationService } from '../services/kkm-setting-navigation.service';
import { KkmAvailableOperations } from '../../../../core/modules/kkms/kkms.types';
import { BillingStatus, IKkm } from '../../../../core/modules/retail-places/retail-paces.types';

@Component({
  selector: 'tax-kkm-network-info',
  templateUrl: './kkm-network-info.component.html',
  styleUrls: ['./kkm-network-info.component.sass'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SharedModule,
    FormsModule,
  ],
})

export class KkmNetworkInfoComponent implements OnInit {
  @Input() kkm?: IKkm & KkmAvailableOperations;
  @Input() simKkmId: null | string = null;
  @Output() simKkmIdChange = new EventEmitter<string | null>();
  billingStatusModel: KkmNetworkBillingStatusModel | null = null;

  constructor(private kkmSettingsNavigationService: KkmSettingsNavigationService) {}

  ngOnInit(): void {
    this.billingStatusModel = this.getBillingStatusModel(this.kkm?.billingStatus);
  }

  goToSelectSubscriptionPage(kkmId: number): void {
    this.kkmSettingsNavigationService.navigateToSelectSubscriptionPage(kkmId);
  }

  getBillingStatusModel(billingStatus?: BillingStatus): KkmNetworkBillingStatusModel | null {
    if (!billingStatus) return null;
    return KKM_NETWORK_TARIFF.find(item => item.billingStatus === billingStatus) ?? null;
  }
}
